import ApiRequestManagerInstance from '../ApiRequestManager';
import DeviceConfig from '@devices/config';
import FlavourConfig from '../../../shared/config/flavours';
import TranslationManager from '../../assets/locale/translationsManager';
import { ILoginRequest } from '../../types/interfaces/login';

function newCodeRequest() {
  const promise = new Promise<string>(async (resolve) => {
    try {
      const response: ILoginRequest = (await ApiRequestManagerInstance.post({
        endpoint: {
          url: 'apiUrl',
          section: 'device',
          subsection: 'newCode',
          params: `/${TranslationManager.currentLanguage}?service=${FlavourConfig.apiService}`,
        },
        data: { idDevice: DeviceConfig.info.uuid },
      })) as unknown as ILoginRequest;
      resolve(`${response.data.device.actCode}`);
    } catch (e) {
      console.error(e);
      resolve('');
    }
  });

  return promise;
}

export default newCodeRequest;
